<template>
    <div class="hot-spot-pannel">
        <div class="pannel-top">
            <span class="pannel-title"
                >{{ title }}
                <Select
                    :initValue="initVal"
                    :options="options"
                    @menuClick="menuClick"
                    v-if="initVal && options.length > 0"
                    class="pannel-option-sele"
                />
            </span>
            <Button :text="exportText" :icon="addIcon" :hoverIcon="addIconHover" @btnClick="exportClick" />
        </div>
        <slot></slot>
    </div>
</template>

<script>
import Button from "@/views/zhiji/bComponents/buttons/Button";
import Select from "@/views/zhiji/bComponents/inputs/Select";

export default {
    name: "HotSpotPannel",
    props: ["title", "options", "initVal"],
    components: {
        Button,
        Select
    },
    data() {
        return {
            addIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -1px -116px",
            addIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -66px -115px"
        };
    },
    computed: {
        exportText() {
            return this.$t("zhiji.hotSpot.exportText");
        }
    },
    methods: {
        exportClick() {
            this.$emit("exportHandle");
        },
        menuClick(data) {
            this.$emit("menuClick", data);
        }
    }
};
</script>

<style lang="scss" scoped>
.hot-spot-pannel {
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 6px;
    margin-top: 16px;
    padding: 8px 24px 16px;

    .pannel-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #d8e4f0;

        .pannel-title {
            display: flex;
            align-items: center;
            font-size: 14px;
        }

        .pannel-option-sele {
            margin-left: 8px;
        }
    }
}
</style>
